import React, { useState } from "react";
import CustomInputField from "../../../customInputField";
import {
  UserIcon,
  ArrowTopRightOnSquareIcon,
  AcademicCapIcon,
} from "@heroicons/react/24/outline";
import ProfileUpload from "../../../profileUpload/ProfileUpload";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useDeleteProfilePhotoMutation } from "../../../../store/professionalInfo";

const AdminGeneralInformation = ({
  professionaInfo,
  handleChange,
  handleProfileChange,
}) => {
  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 767px)").matches;

  const {
    first_name = "",
    last_name = "",
    photo,
  } = professionaInfo || {};

  const [
    deleteProfilePhoto,
    { isLoading: deleteLoading, isSuccess: deleteSuccess },
  ] = useDeleteProfilePhotoMutation();


  return (
    <div className="border border-solid border-[#EBEFF3] p-5 rounded-md mb-6 bg-white">
      <div className="md:flex md:items-center mb-[34px] md:mb-4">
        <h5 className="text-base font-bold leading-[120%] text-customGray">
          General Information
        </h5>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 md:gap-[30px] xl:gap-16 relative mb-[22px]">
        <div className="order-2 xl:order-none flex flex-col justify-between">
          <div>
            <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
              First Name
            </h6>
            <CustomInputField
              icon={UserIcon}
              placeHolder="First Name"
              value={first_name}
              disabled
              name="first_name"
              onChange={handleChange}
              classes="bg-[#DEDEDE] lg:h-[60px] flex items-center mx-auto w-full border border-solid border-[#CCD0D4] rounded-[10px] h-[48px] mb-5 overflow-hidden"
              inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[50px] md:h-[70px] pr-[20px] bg-transparent"
            />
          </div>
          <div>
            <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
              Last Name
            </h6>
            <CustomInputField
              icon={UserIcon}
              disabled
              placeHolder="Last Name"
              value={last_name}
              name="last_name"
              onChange={handleChange}
              classes="bg-[#DEDEDE] mb-0 lg:h-[60px] flex items-center mx-auto w-full border border-solid border-[#CCD0D4] rounded-[10px] h-[48px] overflow-hidden"
              inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[50px] md:h-[70px] pr-[20px] bg-transparent"
            />
          </div>
        </div>
        <div className="bg-[#EBEFF3] w-[1px] h-[90%] absolute left-2/4 bottom-0 -translate-x-2/4 hidden xl:block"></div>
        <div>
          <div className="flex items-center justify-center mb-5">
            <ProfileUpload
              handleProfileChange={handleProfileChange}
              handleDelete={deleteProfilePhoto}
              classes="py-0"
              imageUrl={photo}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminGeneralInformation;
